import React from 'react';

export class FormSwitch extends React.Component {

    render() {
        const {
            col,
            testId,
            disabled,
            label,
            labelDisabled,
            labelEnabled,
            input: {
                value,
            },
        } = this.props;

        return (
            <div className={col}>
                <div className="switch-box">
                    <label>{label}</label>
                    <div className="switch">
                        <label>
                            {labelDisabled}
                            <input
                                type="checkbox"
                                disabled={disabled}
                                checked={value || false} // Para checkboxes emplead el checked, no el value
                                onChange={this.handleOnChange}
                            />
                            <span test-id={testId} className="lever switch-col-blue-grey"/>
                            {labelEnabled}
                        </label>
                    </div>
                    {/* Dejamos la clase CSS error para que introduzca un margen inferior idéntico a los otros campos */}
                    <label className="error"/>
                </div>
            </div>
        );
    }

    handleOnChange = (value) => {
        const {input} = this.props;
        input.onChange(value);
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/components/FormSwitch.jsx